import React from 'react';
import { cn } from '@/lib/utils';
import './styles/card.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const Card: React.FC<CardProps> = ({ children, className, style, onClick }) => (
  <div className={cn('card', className)} style={style} onClick={onClick}>
    {children}
  </div>
);

export const CardHeader: React.FC<CardProps> = ({ children, className, style }) => (
  <div className={cn('card-header', className)} style={style}>
    {children}
  </div>
);

export const CardTitle: React.FC<CardProps> = ({ children, className }) => (
  <h3 className={cn('card-title', className)}>{children}</h3>
);

export const CardDescription: React.FC<CardProps> = ({ children, className }) => (
  <p className={cn('card-description', className)}>{children}</p>
);

export const CardContent: React.FC<CardProps> = ({ children, className, style }) => (
  <div className={cn('card-content', className)} style={style}>
    {children}
  </div>
);

export const CardFooter: React.FC<CardProps> = ({ children, className, style }) => (
  <div className={cn('card-footer', className)} style={style}>
    {children}
  </div>
);
